/* eslint-disable no-console */
import { WrapModal } from './styles';

import ButtonTooltip from '../../ButtonTooltip';

import checkMosaicSCCON from 'views/MapView/services/utils/checkMosaicSCCON';

import Icon from '@map/components/Icons';
import { CircularProgress } from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import CustomDraggable from 'components/ModalDraggable';
import { useEffect, useState } from 'react';
import { useMap, useModule } from 'views/MapView/hooks';

export const SideBySide = ({ mapContext, isActive, setIsActive, ...props }) => {
  const [currentYearLeft, setCurrentYearLeft] = useState(new Date().getFullYear());
  const [currentYearRight, setCurrentYearRight] = useState(new Date().getFullYear());
  const currentDate = new Date();
  const previousMonth = currentDate.getMonth() === 0 ? 12 : currentDate.getMonth();
  const previousYear = currentDate.getMonth() === 0 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
  const [limitYear, setLimitYear] = useState(null);
  const [limitMonth, setLimitMonth] = useState(null);
  const [selectedMonthLeft, setSelectedMonthLeft] = useState(String(previousMonth === 1 ? 12 : previousMonth - 1).padStart(2, '0'));
  const [selectedMonthRight, setSelectedMonthRight] = useState(String(previousMonth).padStart(2, '0'));
  const [selectedYearLeft, setSelectedYearLeft] = useState(previousMonth === 1 ? previousYear - 1 : previousYear);
  const [selectedYearRight, setSelectedYearRight] = useState(previousYear);
  const mergeDateAttribution = `${selectedMonthLeft}/${selectedYearLeft} | ${selectedMonthRight}/${selectedYearRight}`;
  const [count, setCount] = useState(0);
  const [baseMapSCCON, setBaseMapSCCON] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { changeSide, enableSideBySide, disableSideBySide, changeBaseMap, changeAttributionDinamic } = useMap();
  const { activeModule } = useModule();
  const minYear = 2017;
  const maxYear = new Date().getFullYear();
  const months = [
    { number: '01', name: 'Jan' },
    { number: '02', name: 'Fev' },
    { number: '03', name: 'Mar' },
    { number: '04', name: 'Abr' },
    { number: '05', name: 'Mai' },
    { number: '06', name: 'Jun' },
    { number: '07', name: 'Jul' },
    { number: '08', name: 'Ago' },
    { number: '09', name: 'Set' },
    { number: '10', name: 'Out' },
    { number: '11', name: 'Nov' },
    { number: '12', name: 'Dez' },
  ];

  // São usados para ter referencias, ex: na impresão de mapa
  localStorage.setItem('leftSide', `${selectedMonthLeft}/${selectedYearLeft}`);
  localStorage.setItem('rightSide', `${selectedMonthRight}/${selectedYearRight}`);

  /**
   * Monta link para buscar dados no padrao da api da SCCON
   * @param {*} link Link padrao do mapa base da sccon
   * @param {*} side Lado de referencia
   * @param {*} month Mes de referencia
  */
  const updateLink = (link, year, month) => {
    return link.replace(
      /global_monthly_\d{4}_\d{2}_mosaic/,
      `global_monthly_${year}_${month}_mosaic`
    );
  };

  /**
   * Função que escuta mudança de mes/ano no componente
   * @param {*} side Lado de referencia
   * @param {*} month Mes de referencia
  */
  const handleMonthClick = (side, month) => {
    if (side === "left") {
      setSelectedMonthLeft(month);
      setSelectedYearLeft(currentYearLeft);
      changeSide(baseMapSCCON, 'left', updateLink(baseMapSCCON.link, currentYearLeft, month));
    } else if (side === "right") {
      setSelectedMonthRight(month);
      setSelectedYearRight(currentYearRight);
      changeSide(baseMapSCCON, 'right', updateLink(baseMapSCCON.link, currentYearRight, month));
    }
    setCount((prevCount) => prevCount + 1);
  };

  // Responsavel por ativar ferramenta lado a lado
  const activeSideBySide = async () => {
    // Chama funcao de disponibilidade dos mosaicos, o count serve
    // para que seja executado apenas na primeira vez q for renderizado
    if (count === 0) {
      setIsLoading(true)
      await checkBasemapAvailability(selectedYearRight, selectedMonthRight)
      setIsLoading(false)
      setCount((prevCount) => prevCount + 1);
    } else {
      changeBaseMap(null);
      let leftLink = updateLink(baseMapSCCON.link, selectedYearLeft, selectedMonthLeft)
      let rightLink = updateLink(baseMapSCCON.link, selectedYearRight, selectedMonthRight)
      enableSideBySide(baseMapSCCON, leftLink, rightLink)
      changeAttributionDinamic(mergeDateAttribution);
    }
  };

  /**
   * Função responsavel por verificar se o mosaico ja esta disponivel ou nao.
   * Se atentar para a logica do lado direito e lado esquerdo, lado direito deve ser sempre o mais recente,
    lado esquerdo sempre um mes anterior ao direito.

   * Alguns sets precisaram ser feito "na mao grande", para que atenda as nescessidades, ex: a atribuição do mapa

   * Conversoes de string para int ou vice versa, sao nescessarias pois a api da sscon espera uma string no padrao 
    '01', '02' e etc e para fazer calculos de reducao/adicao de mes ou ano precisa do int.
   * @param {*} year Lado de referencia
   * @param {*} month Mes de referencia
  */
  const checkBasemapAvailability = async (year, month) => {
    // Chama service que busca api da sccon se o mosaico referente(mes/ano atual) existe na base de dados deles
    const result = await checkMosaicSCCON(year, month)
    if (result) {
      let rightLink = updateLink(baseMapSCCON.link, result.year, result.month)

      setSelectedYearRight(result.year)
      setSelectedMonthRight(result.month)

      setLimitYear(parseInt(result.year))
      setLimitMonth(parseInt(result.month))
      // Caso o mes mais recente valido seja janeiro, o lado esquerdo deve ser dezembro do ano anterior
      if (result.month === '01') {
        setSelectedYearLeft(result.year - 1)
        setSelectedMonthLeft('12')
        decrementYear('left')

        let leftLink = updateLink(baseMapSCCON.link, result.year - 1, '12');
        enableSideBySide(baseMapSCCON, leftLink, rightLink);
        changeAttributionDinamic(`${12}/${result.year - 1} | ${result.month}/${result.year}`);
      } else {
        // Caso seja qualquer outro mes alem de jan e dezembro, essa logica atende
        setSelectedYearLeft(result.year)
        setSelectedMonthLeft(String(parseInt(result.month) - 1).padStart(2, '0'))

        // Caso o mes mais recente valido seja dezembro, é nescessario decrementar ano do lado esquerod e lado direito
        if (result.month === '12') {
          decrementYear('left')
          decrementYear('right')
        }

        let leftLink = updateLink(baseMapSCCON.link, result.year, String(parseInt(result.month) - 1).padStart(2, '0'));
        enableSideBySide(baseMapSCCON, leftLink, rightLink);
        changeAttributionDinamic(`${String(parseInt(result.month) - 1).padStart(2, '0')}/${result.year} | ${result.month}/${result.year}`);
      }
    }
  };

  /**
   * Adiciona Ano
   * @param {*} side Lado de referencia
  */
  const incrementYear = (side) => {
    if (side === "left" && currentYearLeft < maxYear) {
      setCurrentYearLeft((prev) => prev + 1);
    } else if (side === "right" && currentYearRight < maxYear) {
      setCurrentYearRight((prev) => prev + 1);
    }
  };

  /**
   * Diminui Ano
   * @param {*} side Lado de referencia
  */
  const decrementYear = (side) => {
    if (side === "left" && currentYearLeft > minYear) {
      setCurrentYearLeft((prev) => prev - 1);
    } else if (side === "right" && currentYearRight > minYear) {
      setCurrentYearRight((prev) => prev - 1);
    }
  };

  /**
   * Logica para desabilitar meses invalidos
   * @param {*} side Lado de referencia
   * @param {*} month Mes de referencia
  */
  const isMonthDisabled = (side, month) => {
    const currentMonthNumber = parseInt(month);
    const startMonth = 7; // Julho
    const isLeft = side === 'left';

    // Determina os valores de ano com base no lado
    const currentYear = isLeft ? currentYearLeft : currentYearRight;

    // Desabilita meses antes de julho do ano mínimo
    if (currentYear === minYear && currentMonthNumber < startMonth) {
      return true;
    }

    //Desabilita meses que nao possuem mosaico
    if (limitYear && limitMonth) {
      if (currentYear > limitYear) return true;
      if (currentYear === limitYear && currentMonthNumber > limitMonth) return true;
    }

    // Desabilita todos os meses após o mês inicial no ano de referência
    if (currentYear > previousYear || (currentYear === previousYear && currentMonthNumber > previousMonth)) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    activeModule.basemaps.forEach((item) => {
      if (item.link.includes('sccon')) {
        setBaseMapSCCON(item)
      }
    });
  }, [activeModule]);

  // Responsalvel por fechar a ferramenta e desabilitar o side by side
  useEffect(() => {
    if (isActive === false) {
      disableSideBySide()
      changeBaseMap(baseMapSCCON.id)
      changeAttributionDinamic(localStorage.getItem('mapPlanet'));
    }
  }, [baseMapSCCON, changeAttributionDinamic, changeBaseMap, disableSideBySide, isActive])

  useEffect(() => {
    if (isActive) {
      changeAttributionDinamic(mergeDateAttribution);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  return (
    <>
      <ButtonTooltip
        tooltip={SideBySide.properties.alias}
        description={SideBySide.properties.description}
        onClick={() => {
          activeSideBySide();
          setCurrentYearLeft(selectedYearLeft);
          setCurrentYearRight(selectedYearRight);
          setIsActive();
        }}
        active={isActive}
      >
        <Icon i="map-sideBySide" />
      </ButtonTooltip>
      {isActive && (
        <>
          <CustomDraggable>
            <WrapModal>
              <div className="divIcon"><DragIndicatorIcon /></div>
              {!isLoading ? (
                <div>
                  <div className="divLeft">
                    <div className="divYear">
                      <button onClick={() => decrementYear("left")} disabled={currentYearLeft <= minYear}>{'<'}</button>
                      <span className="spanYear">{currentYearLeft}</span>
                      <button onClick={() => incrementYear("left")} disabled={currentYearLeft >= maxYear}>{'>'}</button>
                    </div>
                    <div className="divMonths">
                      {months.map((month) => (
                        <button
                          key={month.number}
                          disabled={isMonthDisabled("left", month.number)}
                          onClick={() => handleMonthClick("left", month.number)}
                          className={
                            selectedMonthLeft === month.number && selectedYearLeft === currentYearLeft
                              ? 'selected'
                              : ''
                          }
                        >
                          {month.name}
                        </button>
                      ))}
                    </div>
                    <div className="divMosaicCurrent">
                      {selectedMonthLeft && selectedYearLeft ? (
                        <span>
                          à esquerda: {months.find((m) => m.number === selectedMonthLeft)?.name} de {selectedYearLeft}
                        </span>
                      ) : (
                        <span>Nenhum mosaico selecionado</span>
                      )}
                    </div>
                  </div>
                  <div className="divRight">
                    <div className="divYear">
                      <button onClick={() => decrementYear("right")} disabled={currentYearRight <= minYear}>{'<'}</button>
                      <span className="spanYear">{currentYearRight}</span>
                      <button onClick={() => incrementYear("right")} disabled={currentYearRight >= maxYear}>{'>'}</button>
                    </div>
                    <div className="divMonths">
                      {months.map((month) => (
                        <button
                          key={month.number}
                          disabled={isMonthDisabled("right", month.number)}
                          onClick={() => handleMonthClick("right", month.number)}
                          className={
                            selectedMonthRight === month.number && selectedYearRight === currentYearRight
                              ? 'selected'
                              : ''
                          }
                        >
                          {month.name}
                        </button>
                      ))}
                    </div>
                    <div className="divMosaicCurrent">
                      {selectedMonthRight && selectedYearRight ? (
                        <span>
                          à direita: {months.find((m) => m.number === selectedMonthRight)?.name} de {selectedYearRight}
                        </span>
                      ) : (
                        <span>Nenhum mosaico selecionado</span>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="divLoading">
                  <CircularProgress />
                </div>
              )}
            </WrapModal>
          </CustomDraggable>
        </>
      )}
    </>
  );
};

SideBySide.properties = {
  id: 'CPN-TB-RA-SIDE-BY-SIDE',
  alias: 'Lado a Lado',
  description: 'Realiza a comparação de mosaicos de diferentes datas da Planet.',
};

export default SideBySide;
